export default __webpack_public_path__ + "static/media/Logo.c0b31b51.png";